import axios from "axios";
import qs from "qs";
import Bus from './Bus';
import {
  getToken,
  setToken,
  isLogined
} from '@/utils/authorized'

var instance = axios.create({
  baseURL: "/api_mall",
  timeout: 3*60*1000,
  headers: {
    "X-Custom-Header": "foobar",
    "Content-Type": "application/json",
    // "Content-Type": "multipart/form-data",
    'token': getToken()
  }
});
// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    console.log(config, "sfdsdf");
    if (
      config.method.toLowerCase() === "post" &&
      config.data &&
      config.data.formEncode
    ) {
      config.data = qs.stringify(config.data);
    }
    let url = config.url
    if (url.indexOf('/api/reqAuthoriy') > -1) {
      config.baseURL = ''
    }
    if (url.indexOf('my') > -1) {
      config.baseURL = '/api_wmall'
    }

    if (url.indexOf('/billController') > -1) {
      config.baseURL = '/api_b'
    }

    if (url.indexOf('/visitor') > -1) {
      config.baseURL = ''
    }

    if (url.indexOf('/insure') > -1) {
      if (isLogined() != 1) {
        delete config.headers.token
      }
    }
    // 光大
    if (url.indexOf('gd_api') > -1) {
      config.baseURL = ''
    }
    if (url.indexOf('api_ssi') > -1) {
      config.baseURL = ''
    }
	if (url.indexOf('api_cps') > -1) {
	  config.baseURL = ''
	}
    if (url.indexOf('creatMediLinkPdf') > -1 
    || url.indexOf('creatMediLinkQuo')> -1 
    || url.indexOf('queryMediLinkQuo')> -1 
    || url.indexOf('smeCreatMediLinkPdf')> -1
    ||url.indexOf('smeGCWWWEWWCreatMediLinkPdf')> -1
    ||url.indexOf('validCustomerName')> -1
    ) {
      config.baseURL = '/api'
    }
    if(url.indexOf('quotation/add.co')>-1){
      config.credentials = true;
    }
    config.url = url;
    Bus.$emit('show-loading')
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。"
};

const errorHandler = error => {
  const {
    response = {}
  } = error;
  const errortext = codeMessage[response.status] || response.statusText;
  const {
    status,
    url
  } = response;
  if (status === 401) {
    window.notification.error({
      message: "未登录或登录已过期，请重新登录。"
    });
    return;
  }
  // if (error.response) {
  //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
  //   console.log(error.response.data);
  //   console.log(error.response.status);
  //   console.log(error.response.headers);
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   console.log('Error', error.message);
  // }
  // console.log(error.config);
  if (!status) {
    return;
  }
  window.notification.error({
    message: `请求错误 ${status}: ${error.config.url}`,
    description: errortext
  });
  // environment should not be used
  if (status === 403) {
    // router.push('/exception/403');
    return;
  }
  if (status <= 504 && status >= 500) {
    // router.push('/exception/500');
    return;
  }
  if (status >= 404 && status < 422) {
    // router.push('/exception/404');
  }
};
const _hideLoading = function () {
  Bus.$emit('hide-loading')
};
// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    console.log(response.config.url.indexOf('/policyFileUploadController/exportExcelPolicy') > -1, "---------")
    const {
      returnCode,
      returnMsg
    } = response.data;
    _hideLoading();
    if (returnCode !== "0" && returnCode !== "00" && returnCode !== '1018' && returnCode !== '0000' && returnCode !== 'A2004' && returnCode !== '01') {
      const requestUrl = response.config.url;
      if (requestUrl.indexOf('correctPolicy') > -1 || response.config.url.indexOf('closePolicy') > -1) {
        return response;
      } else if (response.config.url.indexOf('/policyFileUploadController/exportExcelPolicy') > -1) {
        return response;
      } else if (response.config.url.indexOf('/policyFileUploadController/exportExcelInsured') > -1 || requestUrl.indexOf('getJsJdkSign.do') > -1) {
        return response;
      }else if(response.config.url.indexOf('queryEnterpriseBank')> -1 ||response.config.url.indexOf('creatMediLinkPdf')> -1 || response.config.url.indexOf('quotation/add.co')> -1 || response.config.url.indexOf('creatMediLinkQuo')> -1 || response.config.url.indexOf('queryMediLinkQuo')> -1|| response.config.url.indexOf('smeCreatMediLinkPdf')>-1||response.config.url.indexOf('smeGCWWWEWWCreatMediLinkPdf')>-1){
        return response;
      } else if (/1012|2004/.test(returnCode)) {
        setToken('')
        var num = Math.ceil(Math.random() * 10);
        window.router.push({
          name: "login",
          params: {
            num
          }
        });
      } else {
        window.message.error(returnMsg);
      }
      return Promise.reject(response);
    }
    return response;
  },
  function (error) {
    _hideLoading()
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      errorHandler(error);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      window.message.error(error.message);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

let api = {};
api.queryProducts = function (data) {
  return instance.post('/store/queryProducts', data);
};
api.queryStore = function (data) {
  return instance.post(`/store/queryStore?${qs.stringify(data)}`, data);
};
// /store/queryProductLablesByTag
api.queryProductLablesByTag = function (data) {
  return instance.post(`/store/queryProductLablesByTag?${qs.stringify(data)}`, data);
};
// /reqAuthoriy/generateUrl
api.generateUrl = function (data) {
  return instance.post(`/api/reqAuthoriy/generateUrl`, data);
};
api.resolveSign = function (data) {
  return instance.post(`/api/reqAuthoriy/decrypt?${qs.stringify(data)}`, data);
};
api.login = function (data) {
  return instance.post(`/diccApi/diccLogin`, data);
};
api.findPwd = function (data) {
  return instance.post('/diccApi/findPwd', data)
};
api.register = function (data) {
  return instance.post(`/diccApi/diccRegist`, data);
};
api.sendSmsCode = function (data) {
  return instance.post(`/diccApi/diccSendMsg`, data);
};
api.queryProduct = function (data) {
  return instance.post(`/diccApi/queryProduct`, data);
};
api.getInsuredLink = function (data) {
  return instance.get(`/diccApi/insure?${qs.stringify(data)}`, data);
};

// 查询商城首页banner和热卖产品
api.queryPcStore = function (data) {
  return instance.get(`/diccApi/queryPcStore?${qs.stringify(data)}`)
}
// 查询产品首页分类和标签
api.queryProductClassList = function (data) {
  return instance.get(`/diccApi/queryProductClassList?${qs.stringify(data)}`)
}
// 查询用户保单
api.findUserPolicy = function (data) {
  return instance.post('/dicc/userPolicy/conditions', data)
}
// 查询保单详情
api.queryPolicyDetail = function (data) {
  return instance.get(`/my/queryPolicyDetail/` + data)
}
// 查询保单下载地址
api.getDownloadPolicyUrl = function (data) {
  return instance.get(`/my/getDownloadPolicyUrl?${qs.stringify(data)}`)
}
// 保单批改
api.correctPolicy = function (data) {
  return instance.post('/my/correctPolicy', data)
}
// 用户批单查询
api.findUserBatchPoloicy = function (data) {
  return instance.post(`/dicc/userPolicy/batch/conditions`, data)
}
// 保单退保
api.closePolicy = function (data) {
  return instance.post('/my/closePolicy', data)
}

//查询史带userID
api.getUserId = function (data) {
  return instance.get('/dicc/userPolicy/getUserId', data)
};
//查询待支付订单
api.queryUnPayInfo = function (data) {
  return instance.post('/payController/queryUnPayInfo', data)
};
// 查询银行区域
api.queryBankAreaInfos = function (data) {
  return instance.get('/my/queryBankAreaInfos')
}
// 根据区域类型查银行种类
api.queryBankTypeInfos = function (data) {
  return instance.get(`/my/queryBankTypeInfos?${qs.stringify(data)}`)
}
// 根据区域类型和银行种类查银行信息
api.queryBankInfos = function (data) {
  return instance.get(`/my/queryBankInfos?${qs.stringify(data)}`)
}
//获取商城个人中心配置信息
api.queryNavBar = function (data) {
  return instance.get('/diccApi/queryNavBar')
}
//添加证件
api.updCertificateInfo = function (data) {
  return instance.put('/dicc/pim/updCertificateInfo', data)
}
//查询已添加证件
api.getCertificateInfo = function (data) {
  return instance.get('/dicc/pim/getCertificateInfo')
}
// 查询用户信息
api.getCustomerWebUser = function (data) {
  return instance.get('/dicc/pim/getCustomerWebUser', data)
}
//修改密码
api.changePassword = function (data) {
  return instance.put('/dicc/pim/changePassword', data)
}
// 发送验证码
api.sendMessage = function (data) {
  return instance.get('/dicc/pim/sendMessage', data)
}
//退出登录
api.logout = function (data) {
  return instance.get('/diccApi/logout', data)
}
// 查询登录协议
api.getRegisterAndPrivacyFiles = function () {
  return instance.get('/diccApi/getRegisterAndPrivacyFiles')
}
//查询商城公司介绍信息
api.getCorePcstore = function (data) {
  return instance.get('/diccApi/getCorePcstore', data)
}
//查询商城常见问题
api.getCoreWxMain = function (data) {
  return instance.get('/diccApi/getCoreWxMain', data)
}
//发票查询
api.queryAllBills = function (data) {
  return instance.post('/billController/queryAllBills', data)
}
//发票对应的保单查询
api.queryBillPolicy = function (data) {
  return instance.post(`/billController/queryBillPolicy?${qs.stringify(data)}`)
}
// 光大商城api暂时放在这里
api.gdLogin = function (data) {
  return instance.get(`/gd_api/policyManageController/queryPolicyUser?${qs.stringify(data)}`)
}
api.queryGdProduct = function (data) {
  return instance.get(`/gd_api/policyManageController/queryAgentProduct?${qs.stringify(data)}`, data)
}
// 查询保单
api.queryGdPolicy = function (data) {
  return instance.post(`/gd_api/policyManageController/queryPolicys?${qs.stringify(data)}`, data)
}
//获取产品计划信息
api.getPolicyPlangd = function (data) {
  return instance.get(`/gd_api/vue/queryPlans?${qs.stringify(data)}`, data);
};
//计算保费变化
api.calPremiumGd = function (data) {
  return instance.post(`/gd_api/vue/calPremium`, data);
};
// 光大批量导入模板
api.uploadFileForInsureds = function (data) {
  return instance.post(`/gd_api/vue/uploadFileForInsureds`, data)
};
// 光大批量导入模板批减
api.descInsuredSingle = function (params, data) {
  return instance.post(`/gd_api/vue/descInsuredSingle?${qs.stringify(params)}`, data)
};
// 光大批量导入模板汇缴单
api.uploadFileForInsuredsS = function (data) {
  return instance.post(`/gd_api/vue/uploadFileForInsuredSingle`, data)
};
//光大保单批改
api.changeOrder = function (data) {
  return instance.post(`/gd_api/vue/changeOrder`, data)
};

//光大保单导出
api.exportExcelPolicy = function (data) {
  return instance.get(`/gd_api/policyFileUploadController/exportExcelPolicy?${qs.stringify(data)}`, {
    responseType: "blob"
  })
};

//光大下级查询
api.queryNextAgencies = function (data) {
  return instance.get(`/gd_api/policyManageController/queryNextAgencies?${qs.stringify(data)}`)
};

//光大修改密码
api.changeGDPassword = function (data) {
  return instance.post(`/gd_api/vue/changePassword`, qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
};

//妇联导出
api.exportExcelInsured = function (data) {
  return instance.get(`/gd_api/policyFileUploadController/exportExcelInsured?${qs.stringify(data)}`, {
    responseType: "blob"
  })
};
api.taAddQuotationData = function (data) {
  return instance.post('/creatMediLinkPdf', data);//非内部版本生成报价书
};
// 校验用户名正确性
api.validCustomerName = function (data) {
  return instance.post('/validCustomerName', data);
}
api.taGetQuotationData = function (data) {
  return instance.get(`/api_ssi/wechatlink/quotation/get/${data}.do`);
};
api.getWxShareSign = function (data) {
  return instance.post(`/api_ssi/wechatlink/common/getJsJdkSign.do`, data);
}
api.CPStrack = function (data) {
  return instance.post(`/api_ssi/wechatlink/quotation/event.do`,data);//访问报价页面埋点
}
api.quoteTrack = function (data) {
  return instance.post('/api_ssi/wechatlink/quotation/add.co', data);//生成报价书埋点
};
api.creatMediLinkQuo = function (data) {
  return instance.post('/salQuotation/creatMediLinkQuo', data);//内部版本生成报价书
};
api.queryMediLinkQuo = function (data) {
  return instance.post('/salQuotation/queryMediLinkQuo', data);//内部版本查询报价
};
api.smeCreatMediLinkPdf = function (data) {
  return instance.post('/smeCreatMediLinkPdf', data);//Aon大陆计划版本生成报价书
};
api.smeGCWWWEWWCreatMediLinkPdf = function (data) {
  return instance.post('/smeGCWWWEWWCreatMediLinkPdf', data);//Aon全球计划版本生成报价书
};
api.queryCustomerCanInsure = function (data) {
  return instance.get(`/hbapi/visitor/queryCustomerCanInsure/${data}`);//Aon全球计划版本生成报价书
};
api.queryEnterpriseBank = function (data) {
  return instance.post('/api_cps/api/invoice/queryEnterpriseBank', data);//企查查接口
};
export default api;